import { schema } from 'normalizr'

export const organization = new schema.Entity('organizations', {}, { idAttribute: 'remoteId' })
export const arrayOfOrganizations = new schema.Array(organization)



// WEBPACK FOOTER //
// ./src/adapters/organizationSchema.js